var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#0042B0",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.49 22.252q-1.89 0-3.186-.81-1.296-.828-1.854-2.304l2.484-1.44q.756 1.746 2.646 1.746 1.71 0 1.71-1.026 0-.576-.558-.864-.576-.342-2.052-.738-1.512-.414-2.556-1.188-1.152-.936-1.152-2.646 0-1.746 1.242-2.79 1.26-1.044 2.988-1.044 1.548 0 2.736.738 1.188.72 1.872 2.106l-2.43 1.422q-.684-1.458-2.178-1.458-.63 0-.99.27t-.36.684q0 .45.432.81.468.36 1.836.756l1.17.378q.45.144 1.044.486.648.324.972.702.864.936.864 2.34 0 1.782-1.296 2.844-1.296 1.026-3.384 1.026M16.521 9.4h4.77q1.872 0 3.132 1.26 1.278 1.278 1.278 3.06t-1.278 3.06q-1.26 1.26-3.132 1.26h-1.89V22h-2.88zm2.88 5.94h1.89q.666 0 1.098-.468t.432-1.152-.432-1.152a1.43 1.43 0 0 0-1.098-.468h-1.89z"
  })));
};
export default SvgLogo;